window.infoLineaTiempoMuertoSoplado = null;

if (window.location.pathname === "/soplado/periodo" || window.location.pathname === "/zona-trabajo") {
    
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const modalEditarTiempoMuerto = document.querySelector("#formEditarTiempoMuertoSoplado");
    let idLineaProduccion = modalEditarTiempoMuerto.querySelector("#idLineaTiempoMuertoSoplado").value;
    
    window.infoLineaTiempoMuertoSoplado = (idLineaProduccion) => {
        
        const url = `/api/soplado/lineaTiempoMuerto?idLine=${idLineaProduccion}`;

        const divModalEditarTiempoMuerto = document.querySelector("#contEditarTiempoMuertoSoplado");
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                const data = Array.isArray(result.result) ? result.result[0] : null;

                if (!data) {
                    throw new Error("No se encontró la línea de tiempo muerto de soplado solicitada.");
                }
                
                const int = n => (Number(n) || 0);
                
                divModalEditarTiempoMuerto.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));
                
                const horaInicio = divModalEditarTiempoMuerto.querySelector("#horaInicio");
                const horaFin = divModalEditarTiempoMuerto.querySelector("#horaFin");
                const idCausaTiempoMuerto = divModalEditarTiempoMuerto.querySelector("#idCausaTiempoMuerto");
                divModalEditarTiempoMuerto.classList.toggle('canvaBloqueado', Number(data.estadoReporteSoplado) != 1);
                const contBtnModal = divModalEditarTiempoMuerto.querySelector('.contBtnModal');
                if (contBtnModal) {
                    contBtnModal.classList.toggle('oculto', Number(data.estadoReporteSoplado) != 1);
                }

                if (horaInicio && horaFin && idCausaTiempoMuerto) {
                    horaInicio.value = data.horaInicio;
                    horaFin.value = data.horaFin;
                    idCausaTiempoMuerto.value = int(data.idCausaTiempoMuerto);
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrió un error al cargar la información del tiempo muerto. Por favor, intenta nuevamente.");
                return;
            });
    };

    document.addEventListener('click', function (e) {
        const trAbrir = e.target.closest('.trSelectTiempoMuerto[data-modal="modalEditarTiempoMuertoSoplado"]');
        if (trAbrir) {
            const idLineaProduccion = trAbrir.getAttribute('data-id');
            const modalEditarTiempoMierto = document.querySelector('#formEditarTiempoMuertoSoplado');
            const modalPadre = document.querySelector('#modalProduccionSoplado');
            const inputReporteSoplado = modalPadre ? modalPadre.querySelector('#idReporteSoplado') : null;
            const idEncabezado = inputReporteSoplado ? inputReporteSoplado.value : '';

            if (!idLineaProduccion || !modalEditarTiempoMierto || !idEncabezado) {
                alert("No se encontró el ID de la línea de producción o es inválido.");
                return;
            }else{
                let inputIdLinea = modalEditarTiempoMierto.querySelector('#idLineaTiempoMuertoSoplado');
                let inputIdReporte = modalEditarTiempoMierto.querySelector('#idEncabezadoReporteSoplado');

                if(inputIdLinea && inputIdReporte){
                    inputIdLinea.value = idLineaProduccion;
                    inputIdReporte.value = idEncabezado;
                    window.infoLineaTiempoMuertoSoplado(idLineaProduccion);
                }else{
                    alert("No se encontró el campo oculto para el ID del encabezado del reporte.");
                    return;
                }
            }
        }
    });
}
